/* eslint-disable react/prop-types */
import React from 'react'
import ResetPasswordModal from '../../engage/modals/ResetPasswordModal'
import RevokeSessionsModal from '../RevokeSessionsModal'
import UnblockSignInModal from '../UnblockSignInModal'
import { MODALS } from './useIntegrationModals'

function IntegrationModals(props) {
  const {
    closeIntegrationModal,
    modalData,
    modalSize,
    onSubmitRequest,
    showBlockSignInModal = true,
    onSuccessUpdateIntegrationManager,
    openedModal,
    selectedEmployees,
    onBackToEmployeeModal,
  } = props

  return (
    <>
      {openedModal === MODALS.RESET_PASSWORD && (
        <ResetPasswordModal
          show
          onHide={closeIntegrationModal}
          employee={selectedEmployees[0]} // last added employee
          onUpdate={onSuccessUpdateIntegrationManager}
          toBackdrop={false}
          headerBackButtonAction={onBackToEmployeeModal}
        />
      )}
      {(openedModal === MODALS.UNBLOCK_SIGNIN || openedModal === MODALS.BLOCK_SIGNIN) && (
        <UnblockSignInModal
          show={showBlockSignInModal}
          onUpdate={onSuccessUpdateIntegrationManager}
          onHide={closeIntegrationModal}
          employees={selectedEmployees}
          modalType={openedModal}
          onBack={onBackToEmployeeModal}
          onSubmitRequest={onSubmitRequest}
          size={modalSize}
        />
      )}
      {openedModal === MODALS.REVOKE_SESSIONS && (
        <RevokeSessionsModal
          show
          {...modalData}
          onHide={closeIntegrationModal}
          employee={selectedEmployees[0]}
          onUpdate={onSuccessUpdateIntegrationManager}
          onBack={onBackToEmployeeModal}
        />
      )}
    </>
  )
}

export default IntegrationModals
